import { ChangeIndicator } from './ChangeIndicator'
import styles from './Widgets.module.css'

// The number and how it moved, beside the metric's icon. A tile that also
// drew a sparkline spent most of its height on a shape too small to read, and
// the trend belongs to the expanded view where there is room for an axis. The
// number grows with the tile's width; the icon steps aside on a narrow tile
// rather than squeezing it. With the comparison off the tile is the number
// alone: the switch that turned it off is on the toolbar, and a row of tiles
// each saying so said nothing.
export function MetricTile({ value, change, note, icon: Icon }) {
  return (
    <div className={styles.tile} data-with-icon={Icon ? true : undefined}>
      {Icon ? (
        <span className={styles.tileIcon} aria-hidden="true">
          <Icon className={styles.tileIconGlyph} />
        </span>
      ) : null}
      <div className={styles.tileFigures}>
        <p className={styles.tileValue}>{value}</p>
        {change ? <ChangeIndicator change={change} className={styles.tileChange} /> : null}
        {note ? <p className={styles.tileNote}>{note}</p> : null}
      </div>
    </div>
  )
}

// The same number in the shape the expanded views use: label, value, change.
// Rates read as cards here so a row of them compares at a glance.
export function StatCards({ items, label, columns }) {
  return (
    <dl className={styles.cards} aria-label={label} style={columns ? { '--cards-columns': columns } : undefined}>
      {items.map((item) => (
        <div key={item.label} className={styles.card}>
          <dt className={styles.cardLabel}>{item.label}</dt>
          <dd className={styles.cardValue}>{item.value}</dd>
          <ChangeIndicator as="dd" change={item.change} className={styles.cardChange} />
          {item.note ? <dd className={styles.cardNote}>{item.note}</dd> : null}
        </div>
      ))}
    </dl>
  )
}
